import React from "react";
import LayOut from "../../components/LayOut";

const CreateClient = () => {
  return (
    <LayOut>
      <div>Create Client</div>
    </LayOut>
  );
};

export default CreateClient;
